import { api } from './api';

export interface LocationInfo {
  id: string | null;
  city: string;
  region: string;
  country: string;
  label: string;
  isHome: boolean;
  firstSeen: string | null;
  lastSeen: string | null;
  locationHash: string;
}

export interface CheckinResponse {
  allowed: boolean;
  currentLocation: LocationInfo;
  locations: LocationInfo[];
  limit: number;
  message?: string;
}

export interface LocationsResponse {
  locations: LocationInfo[];
  limit: number;
}

export const sessionService = {
  checkin: (): Promise<CheckinResponse> =>
    api.post('/api/sessions/checkin'),

  getLocations: (): Promise<LocationsResponse> =>
    api.get('/api/sessions/locations'),

  releaseLocation: (id: string): Promise<{ success: boolean }> =>
    api.delete(`/api/sessions/locations/${id}`),

  renameLocation: (id: string, label: string): Promise<{ success: boolean }> =>
    api.put(`/api/sessions/locations/${id}/label`, { label }),

  markHome: (id: string): Promise<{ success: boolean }> =>
    api.put(`/api/sessions/locations/${id}/home`),
};

export default sessionService;
